import { render, staticRenderFns } from "./Level0-4.vue?vue&type=template&id=6cca880d&scoped=true&"
import script from "./Level0-4.vue?vue&type=script&lang=js&"
export * from "./Level0-4.vue?vue&type=script&lang=js&"
import style0 from "./Level0-4.vue?vue&type=style&index=0&id=6cca880d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cca880d",
  null
  
)

export default component.exports